// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleColumnLayout_container__30T0e","column":"SingleColumnLayout_column__2xWMM"};